import React from 'react'
import { ModelDoc } from '../docs_model'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import CardDoc from './CardDoc'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	listContainer: {
		marginTop: '4%',
		display: 'flex',
		flexDirection: 'column'
	}
}))

interface AcceptingProps {
	docs: Array<ModelDoc>

}

type ListDocProps = AcceptingProps

const ListDoc: React.FC<ListDocProps> = (
	{
		docs
	}
) => {
	const classes = useStyle()
	return (
		<div className={classes.listContainer}>
			{
				docs.map((doc: ModelDoc) => (
					<CardDoc doc={doc} />
				))
			}
		</div>
	)
}

export default ListDoc